import { Badge } from "@/components/ui/badge";
import type { EntityListBlock } from "@/types/blocks";

import { EntityLink } from "../EntityLink";
import { isEntityRef } from "../entity-refs";

/** A list of clickable entity chips with an optional subtitle, badges, and a
 *  right-aligned meta line. Deep-links reuse `<EntityLink>`. */
export function EntityListBlockView({ block }: { block: EntityListBlock }) {
  return (
    <div className="flex flex-col overflow-hidden rounded-md border border-border bg-card">
      {block.title && (
        <div className="border-b border-border px-3 py-2 text-sm font-medium text-foreground">
          {block.title}
        </div>
      )}
      {block.items.map((item, i) => (
        <div
          key={i}
          className="flex items-center justify-between gap-3 border-b border-border px-3 py-2 last:border-0"
        >
          <div className="flex min-w-0 flex-col gap-0.5">
            {isEntityRef(item.entity_ref) ? (
              <EntityLink entity={item.entity_ref} />
            ) : (
              <span className="text-sm text-foreground">{item.entity_ref.label}</span>
            )}
            {item.subtitle && (
              <span className="truncate text-xs text-muted-foreground">{item.subtitle}</span>
            )}
            {item.badges.length > 0 && (
              <div className="flex flex-wrap gap-1">
                {item.badges.map((b, j) => (
                  <Badge key={j} variant="default">
                    {b}
                  </Badge>
                ))}
              </div>
            )}
          </div>
          {item.meta && (
            <span className="shrink-0 text-sm text-muted-foreground tabular-nums">{item.meta}</span>
          )}
        </div>
      ))}
    </div>
  );
}
